import request from '@/utils/axios.js'

// let testUrl = 'http://api.isc.360zqaq.net'
// let testUrl = ''
// config配置
export function getRecruit(id) {
  return request.get(`/portal/index/config?id=${id}&t=${new Date().getTime()}`)
}
// 新闻中心
export function getNews(id) {
  return request.get(`/other/aqk/subject?id=${id}&t=${new Date().getTime()}`)
}

// 大会日程二级页
export function getSchedule(date, type, id=1) {
  return request.get(`club/meet/index?activity_id=${id}&meet_date=${date}&type=${type}&t=${new Date().getTime()}`)
}
// 大会获取视频地址
export function getScheduleVidoe(id) {
  return request.get(`video/index/videoinfo?vid=${id}&t=${new Date().getTime()}`)
}
// 大会日程三级页
export function getScheduleDetail(id) {
  return request.get(`club/meet/detail?meet_id=${id}&t=${new Date().getTime()}`)
}
export function getKeyGuest(title,id=1) {
  return request.get(`club/speaker/index?activity_id=${id}&title=${title}&t=${new Date().getTime()}`)
}
// 所有嘉宾
export function getAllGuest(id=1) {
  return request.get(`/club/speaker/index?activity_id=${id}&t=${new Date().getTime()}`)
}
//submodule相关接口
export function getStartupIncubation(id) {
  return request.get(`/website/index/info?id=${id}`)
}
//报告详情
export function getReportDetail(id) {
  return request.get(`/website/index/content?id=${id}`)
}
//评选数字安全及AI大模型
export function getAwardWin(year) {
  return request.get(`/webapi/innovation/top/prizeList?year=${year}`)
}

//评选数字安全及AI大模型
export function getnewList() {
  return request.get(`/webapi/innovation/top/applyList`)
}
//活动列表
export function getActivityList(id) {
  return request.get(`/club/activity/list?activity_id=${id}`)
}
//活动列表详情
export function getActivityDetailList(id) {
  return request.get(`/club/activity/detail?id=${id}`)
}
